export default "__VITE_ASSET__b53b528f__"